import { ITableFilterItem } from '@components/common/UTable/UTable';
import { DatePickerProps } from 'antd';
import dayjs from 'dayjs';

import { Dictionaries } from '@/api/dictionaries/types';
import { OrganizationShort } from '@/api/organizations/types';
import { dictToOptions } from '@/utils/utils';

export const filterSchema = (
  dictionaries?: Dictionaries,
  organizations?: OrganizationShort[],
): ITableFilterItem[] => [
  {
    label: 'Инвентарный номер',
    placeholder: 'Введите инвентарный номер',
    key: 'inventoryNumber',
    type: 'text',
  },
  {
    label: 'Хозяйство',
    placeholder: 'Выберите хозяйство',
    key: 'organizationId',
    type: 'select',
    payload: {
      options: organizations?.map((value) => ({
        label: value.shortName,
        value: value.id,
      })),
    },
  },
  {
    label: 'Объект',
    placeholder: 'Выберите объект',
    key: 'individualLocationId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.INDIVIDUAL_LOCATION),
    },
  },
  {
    label: 'Дата рождения',
    key: 'birthDate',
    type: 'dateRange',
    payload: {
      disabledDate: (current: DatePickerProps['value']) => {
        return current && current > dayjs().endOf('day');
      },
      // defaultValue: [dayjs(), dayjs()],
    },
  },
  {
    label: 'Вид животного',
    placeholder: 'Выберите вид животного',
    key: 'animalSpeciesId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
  },
];
